import ReportTable from '../../../../../components/Grid/ReportTable';

export default function ComandasTable(props: any) {
  return <ReportTable model={props.model} columnCount={9} />;
}
